var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentCut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "126.77 -836.31 706.46 712.62",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m759.38-162.46-276.3-275.31L365.31-319q8.77 16 13.42 32.47t4.65 34.09q0 54.02-36.84 91.38-36.84 37.37-91.38 37.37-52.89 0-90.64-37.34-37.75-37.35-37.75-90.89t37.36-90.96q37.37-37.43 91.38-37.43 17.63 0 34.1 5.16 16.47 5.15 32.47 13.92L440.85-479 322.08-597.77q-16 8.77-32.47 13.42-16.47 4.66-34.1 4.66-54.01 0-91.38-37.34-37.36-37.35-37.36-90.89t37.34-90.96q37.34-37.43 90.89-37.43 53.54 0 90.96 37.37 37.42 37.36 37.42 91.38 0 17.62-4.65 34.09T365.31-641l467.92 465.92v12.62zM579.62-532.31l-43.24-43.23 223-222h73.85v12.62zm-324.3-79.38q39.83 0 67.95-28.37 28.11-28.36 28.11-68.19t-28.36-67.94q-28.36-28.12-68.19-28.12t-67.95 28.37q-28.11 28.36-28.11 68.19t28.36 67.94q28.37 28.12 68.19 28.12M483.08-476q1.6 0 2.8-1.2t1.2-2.8-1.2-2.8-2.8-1.2-2.8 1.2-1.2 2.8 1.2 2.8 2.8 1.2M255.32-155.69q39.83 0 67.95-28.37 28.11-28.36 28.11-68.19t-28.36-67.94q-28.36-28.12-68.19-28.12t-67.95 28.37q-28.11 28.36-28.11 68.19t28.36 67.94q28.37 28.12 68.19 28.12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCut);
export default __webpack_public_path__ + "static/media/content_cut.8c71e39d7619b08edb49871b0133eac4.svg";
export { ForwardRef as ReactComponent };